import { createContext } from "react";

const headerContext= createContext("")

export default headerContext